import React, { Suspense, useRef, useEffect, useState } from 'react';
import StyledHome from './styles/HomePageStyles';
import Fold from '@/components/landing/home/Fold';
import Prices from '@/components/landing/home/PriceMarquee';
import SEOMetadata from '@/components/SEOMetadata';
import { useIdlePrefetch } from '@/hooks/useIdlePrefetch';

const loadNumbersGrid = () => import('@/components/landing/home/NumbersGrid');
const NumbersGrid = React.lazy(loadNumbersGrid);
const loadUseCases = () => import('@/components/landing/home/UseCases');
const UseCases = React.lazy(loadUseCases);
const loadProductsGrid = () => import('@/components/landing/home/ProductsGrid');
const ProductsGrid = React.lazy(loadProductsGrid);
const loadInteractiveAPI = () => import('@/components/landing/home/InteractiveAPI');
const InteractiveAPI = React.lazy(loadInteractiveAPI);
const loadSliders = () => import('@/components/landing/home/Sliders');
const Sliders = React.lazy(loadSliders);
const loadInplace = () => import('@/components/landing/home/FeaturesInplace');
const Inplace = React.lazy(loadInplace);
const loadStats = () => import('@/components/landing/home/Stats');
const Stats = React.lazy(loadStats);
const loadTextRoll = () => import('@/components/landing/home/TextRoll');
const TextRoll = React.lazy(loadTextRoll);
const loadFeatureCards = () => import('@/components/landing/home/FeatureCards');
const FeatureCards = React.lazy(loadFeatureCards);
const loadPlatform = () => import('@/components/landing/home/Platform');
const Platform = React.lazy(loadPlatform);
const loadPricing = () => import('@/components/landing/PricingTable');
const Pricing = React.lazy(loadPricing);
const loadBlogs = () => import('@/components/landing/home/BlogCards');
const Blogs = React.lazy(loadBlogs);
const loadGetStarted = () => import('@/components/landing/GetStarted');
const GetStarted = React.lazy(loadGetStarted);
const loadFooter = () => import('@/components/landing/Footer');
const Footer = React.lazy(loadFooter);

const HomePage: React.FC = () => {
  useIdlePrefetch([loadNumbersGrid, loadUseCases, loadProductsGrid, loadInteractiveAPI, loadSliders, loadInplace, loadStats, loadTextRoll, loadFeatureCards, loadPlatform, loadPricing, loadBlogs, loadGetStarted, loadFooter]);
  const graphicRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(true);


    useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: '300px',
        threshold: 0.01
      }
    );

    if (graphicRef.current) {
      observer.observe(graphicRef.current);
    }

    return () => {
      if (graphicRef.current) {
        observer.unobserve(graphicRef.current);
      }
    };
  }, []);



  useEffect(() => { window.track('home_page_visited') }, []);



  return (
    <>
      <SEOMetadata
        title="Market, Fundamental & Alternative Data API"
        description="Historical financial data via a single API. Stocks, ETFs, forex, crypto, fundamentals, sentiment, ESG, and alternative data. Free tier."
        canonicalUrl="https://axionquant.com/"
      />

      <StyledHome>

        <div ref={graphicRef}>
          <Fold isVisible={isVisible} />
          <Prices />
        </div>


          <NumbersGrid />
          <UseCases />
          <ProductsGrid isVisible={isVisible}  />

        <Suspense fallback={null}>

        <div className="interactve-api">

          <div className="text">
            <h2 className="serif"> Clean and effortless financial data APIs </h2>
            <p> Pull stock market data, fundamentals, and SEC filings with your first request and leave the wrangling in the past. </p>
          </div>
            <InteractiveAPI />

        </div>

          <Sliders />

          <Inplace/>
          <Stats/>

          <TextRoll/>

          <FeatureCards/>

          <Platform/>


          <Pricing/>

          <div className="blog">
            <Blogs/>
          </div>


          <GetStarted/>

          <Footer/>
        </Suspense>
      </StyledHome>
    </>
  );
};

export default HomePage;
